import { render, staticRenderFns } from "./CheckIndex.vue?vue&type=template&id=6a7a01b2"
import script from "./CheckIndex.vue?vue&type=script&lang=js"
export * from "./CheckIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports